import AuthService from "../../utilities/services/auth.service";

import { PaginationProvider } from "../../providers/PaginationProvider/PaginationProvider";
import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { FlexPacksWrapper } from "../../components";

export default function FlexPacksPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <PaginationProvider>
      <ModalProvider>
        <FlexPacksWrapper organization={organization} />
      </ModalProvider>
    </PaginationProvider>
  );
}
